import revisionNumbersList from "./associate-editors/revision-number";

export default [...revisionNumbersList];